<template>
  <div class="reportLoading">
    <div class="listComSelect">
      <span class="weekTitle" @click="actionSheet = true">{{ titleTime }}</span>
      <van-dropdown-menu>
        <van-dropdown-item v-model="com_id" :options="listCom" />
      </van-dropdown-menu>
    </div>
    <van-divider />
    <div class="title">发运车辆统计</div>
    <van-divider />
    <div v-if="showEmpty" class="emptyDiv">
      <Empty></Empty>
    </div>
    <div class="pieDiv">
      <div class="pieCanvas" ref="pieCanvas"></div>
    </div>
    <div class="listDiv">
      <div class="greedDiv"></div>
      <div>
        <p class="Accout">每周发运车辆统计</p>
      </div>
      <!-- <van-divider /> -->
    </div>
    <div style="padding:0 10px;">
      <el-table
        ref="elTable"
        v-if="this.tableData.length > 0"
        class="elTable"
        :data="tableData"
        style="width: 100%"
        height="auto"
        max-height="50vh"
      >
        <el-table-column
          fixed
          prop="comName"
          label="承运商"
          width="120"
        ></el-table-column>
        <el-table-column prop="week1" label="周一" width="50"></el-table-column>
        <el-table-column prop="week2" label="周二" width="50"></el-table-column>
        <el-table-column prop="week3" label="周三" width="50"></el-table-column>
        <el-table-column prop="week4" label="周四" width="50"></el-table-column>
        <el-table-column prop="week5" label="周五" width="50"></el-table-column>
        <el-table-column prop="week6" label="周六" width="50"></el-table-column>
        <el-table-column prop="week7" label="周日" width="50"></el-table-column>
      </el-table>
    </div>
    <van-action-sheet v-model="actionSheet" close-on-click-action>
      <van-picker
        title=""
        show-toolbar
        visible-item-count="5"
        value-key="showName"
        :columns="columns"
        @confirm="onConfirm"
        @cancel="onCancel"
        @change="onChange"
      />
    </van-action-sheet>
  </div>
</template>

<script>
import Empty from "@/components/tips/Empty.vue";
import moment from "moment";
export default {
  data() {
    return {
      beginDate: "",
      endDate: "",
      listCom: [],
      com_id: "",
      pieData: [],
      colorList: [
        "#FF9F7F",
        "#37A2DA",
        "#8378EA",
        "#FFDB5C",
        "#67E0E3",
        "#E690D1",
        "#E062AE",
        "#9FE6B8",
        "#96BFFF",
        "#FB7293",
        "#9D96F5",
        "#E7BCF3",
        "#32C5E9",
        "#F5AD95",
        "#F8AABD",
        "#FDE079",
        "#F5CFD8",
        "#F996AE",
        "#82E4E6",
        "#F6C1CE",
        "#F4E2E6"
      ],
      tableData: [],
      showEmpty: false,
      weekName: [],
      dataList: [],
      fullName: [],
      actionSheet: false,
      columns: []
    };
  },
  computed: {
    percentText() {
      return pr => {
        let all = 0;
        this.pieData.forEach(item => {
          all += Number(item.value);
        });
        return (pr / all).toFixed(2) * 100 + "%";
      };
    },
    allText() {
      let all = 0;
      this.pieData.forEach(item => {
        all += Number(item.value);
      });
      return all;
    },
    titleTime() {
      let text = "";
      // let s = moment(this.beginDate).format("MM月DD日");
      // let e = "";
      // if (this.endDate.length == 0) {
      //   e = moment(this.beginDate)
      //     .add(6, "days")
      //     .format("MM月DD日");
      // } else {
      //   e = moment(this.endDate).format("MM月DD日");
      // }
      // text = s + "-" + e;
      for (let i = 0; i < this.columns.length; i++) {
        let element = this.columns[i];
        if (this.beginDate == element.begin_date) {
          text = element.showName;
        }
      }
      return text;
    }
  },
  async mounted() {
    this.creatPie();
  },
  watch: {
    async com_id() {
      // this.getData();
      this.creatPie();
    }
  },
  created() {
    this.beginDate = this.$route.query.begin_date;
    this.getListCome();
    this.getweekList();
  },
  components: {
    Empty
  },
  methods: {
    async creatPie() {
      if (this.beginDate.length == 0) {
        return;
      }
      const resData = await this.getData();
      let option = this.getPeiOption(resData);
      if (option.length == 0) {
        return;
      }
      let pieEl = null;
      if (!pieEl) {
        pieEl = this.$echarts.init(this.$refs.pieCanvas);
      }
      pieEl.setOption(option, true);
    },
    getListCome() {
      this.$common
        .http({
          url: "/api/queue/summary/list_com"
        })
        .then(res => {
          this.listCom = [{ text: "所有厂区", value: "" }];
          res.data.data.forEach(element => {
            this.listCom.push({ text: element.name, value: element.id });
          });
        });
    },
    getData() {
      return this.$common.http({
        url: "/api/queue/summary/car_wreport",
        data: {
          com_id: this.com_id,
          begin_date: this.beginDate
          // begin_date: "2020-11-23"
        }
      });
    },
    getPeiOption(resData) {
      // return {
      //   color: this.colorList,
      //   tooltip: {
      //     trigger: "axis",
      //     axisPointer: {
      //       type: "shadow"
      //     }
      //   },
      //   grid: {
      //     right: 10
      //   },
      //   dataZoom: [
      //     {
      //       show: true,
      //       realtime: true,
      //       start: 0,
      //       end: 20
      //     },
      //     {
      //       type: "inside",
      //       realtime: true,
      //       start: 0,
      //       end: 20
      //     }
      //   ],
      //   legend: {
      //     data: ["周一", "周二", "周三", "周四", "周五"],
      //     top: 1
      //   },
      //   xAxis: {
      //     type: "category",
      //     data: ["物流1", "物流2", "物流3", "物流4", "物流5", "物流6", "物流7"],
      //     axisLabel: {
      //       rotate: 0
      //     }
      //   },
      //   yAxis: {},
      //   series: [
      //     {
      //       type: "bar",
      //       name: "周一",
      //       data: [43.3, 85.8, 93.7, 83.8, 91.7, 43.3, 85.8],
      //       label: {
      //         show: true,
      //         position: "top",
      //         fontSize: 11
      //       }
      //     },
      //     {
      //       type: "bar",
      //       name: "周二",
      //       data: [83.1, 73.4, 55.1, 86.8, 92.7, 43.3, 85.8],
      //       label: {
      //         show: true,
      //         position: "top",
      //         fontSize: 11
      //       }
      //     },
      //     {
      //       type: "bar",
      //       name: "周三",
      //       data: [86.4, 65.2, 82.5, 89.8, 93.7, 43.3, 85.8],
      //       label: {
      //         show: true,
      //         position: "top",
      //         fontSize: 11
      //       }
      //     },
      //     {
      //       type: "bar",
      //       name: "周四",
      //       data: [72.4, 53.9, 39.1, 80.8, 94.7, 43.3, 85.8],
      //       label: {
      //         show: true,
      //         position: "top",
      //         fontSize: 11
      //       }
      //     },
      //     {
      //       type: "bar",
      //       name: "周五",
      //       data: [72.4, 53.9, 39.1, 81.8, 95.7, 43.3, 85.8],
      //       label: {
      //         show: true,
      //         position: "top",
      //         fontSize: 11
      //       }
      //     }
      //   ]
      // };

      let dataList = [];
      let weekName = [];
      let fullName = [];
      if (resData.data.data == undefined || resData.data.data.length == 0) {
        this.showEmpty = true;
        document.getElementById("app").style.overflow = "hidden";
        return [];
      }
      this.showEmpty = false;
      document.getElementById("app").style.overflow = "auto";
      resData.data.data.forEach(item => {
        weekName = [];
        console.log(Object.keys(item));
        Object.keys(item).forEach(key => {
          let name = "";
          if (key == "1") {
            name = "周一";
            if (Array.isArray(dataList[0])) {
              dataList[0].push(item[key]);
            } else {
              dataList[0] = [];
              dataList[0].push(item[key]);
            }
          }
          if (key == "2") {
            name = "周二";
            if (Array.isArray(dataList[1])) {
              dataList[1].push(item[key]);
            } else {
              dataList[1] = [];
              dataList[1].push(item[key]);
            }
          }
          if (key == "3") {
            name = "周三";
            if (Array.isArray(dataList[2])) {
              dataList[2].push(item[key]);
            } else {
              dataList[2] = [];
              dataList[2].push(item[key]);
            }
          }
          if (key == "4") {
            name = "周四";
            if (Array.isArray(dataList[3])) {
              dataList[3].push(item[key]);
            } else {
              dataList[3] = [];
              dataList[3].push(item[key]);
            }
          }
          if (key == "5") {
            name = "周五";
            if (Array.isArray(dataList[4])) {
              dataList[4].push(item[key]);
            } else {
              dataList[4] = [];
              dataList[4].push(item[key]);
            }
          }
          if (key == "6") {
            name = "周六";
            if (Array.isArray(dataList[5])) {
              dataList[5].push(item[key]);
            } else {
              dataList[5] = [];
              dataList[5].push(item[key]);
            }
          }
          if (key == "7") {
            name = "周日";
            if (Array.isArray(dataList[6])) {
              dataList[6].push(item[key]);
            } else {
              dataList[6] = [];
              dataList[6].push(item[key]);
            }
          }
          if (
            key == "1" ||
            key == "2" ||
            key == "3" ||
            key == "4" ||
            key == "5" ||
            key == "6" ||
            key == "7"
          ) {
            weekName.push(name);
          }
          if (key == "short_name") {
            fullName.push(item[key]);
          }
        });
      });

      let seriesData = [];
      this.weekName = weekName;
      this.dataList = dataList;
      this.fullName = fullName;
      weekName.forEach((item, index) => {
        seriesData.push({
          type: "bar",
          name: item,
          data: dataList[index],
          label: {
            show: true,
            position: "top",
            fontSize: 11
          }
        });
      });
      this.tableData = [];
      let sumWeek1 = 0;
      let sumWeek2 = 0;
      let sumWeek3 = 0;
      let sumWeek4 = 0;
      let sumWeek5 = 0;
      let sumWeek6 = 0;
      let sumWeek7 = 0;
      fullName.forEach((item, index) => {
        sumWeek1 += dataList[0][index];
        sumWeek2 += dataList[1][index];
        sumWeek3 += dataList[2][index];
        sumWeek4 += dataList[3][index];
        sumWeek5 += dataList[4][index];
        sumWeek6 += dataList[5][index];
        sumWeek7 += dataList[6][index];
        this.tableData.push({
          comName: item,
          week1: dataList[0][index],
          week2: dataList[1][index],
          week3: dataList[2][index],
          week4: dataList[3][index],
          week5: dataList[4][index],
          week6: dataList[5][index],
          week7: dataList[6][index]
        });
      });
      this.tableData.push({
        comName: "总计",
        week1: sumWeek1,
        week2: sumWeek2,
        week3: sumWeek3,
        week4: sumWeek4,
        week5: sumWeek5,
        week6: sumWeek6,
        week7: sumWeek7
      });

      console.log(weekName, fullName, seriesData);

      return {
        color: this.colorList,
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        grid: {
          right: 10,
          bottom: 80,
          top: 75
        },
        dataZoom: [
          {
            show: true,
            realtime: true,
            start: 0,
            end: 20,
            showDataShadow: false
          },
          {
            type: "inside",
            realtime: true,
            start: 0,
            end: 20,
            showDataShadow: false
          }
        ],
        legend: {
          data: weekName,
          top: 0
        },
        xAxis: {
          type: "category",
          data: fullName,
          axisLabel: {
            rotate: 48
          }
        },
        yAxis: { type: "value", minInterval: 1 },
        series: seriesData
      };
    },
    onConfirm(value) {
      console.log(value);
      this.actionSheet = false;
      this.beginDate = value.begin_date;
      this.endDate = value.end_date;
      this.creatPie();
    },
    onCancel(e) {
      console.log(e);
      this.actionSheet = false;
    },
    onChange(e) {
      console.log(e);
    },
    getweekList() {
      this.$common
        .http({
          url: "/api/queue/summary/get_year_week",
          data: {
            year: [new Date().getFullYear(), new Date().getFullYear() - 1]
          }
        })
        .then(res => {
          let weeklist = res.data.data.week_data;
          weeklist.forEach(item => {
            item.showName = `${item.year}年第${item.week}周
            ${moment(item.begin_date).format("MM月DD日")}-${moment(
              item.end_date
            ).format("MM月DD日")}`;
          });
          this.columns = weeklist;
          if (this.beginDate.length == 0) {
            this.beginDate = moment(res.data.data.self_week.begin_date).format(
              "YYYY-MM-DD"
            );
            this.creatPie();
          }
        });
    }
  }
};
</script>
<style scoped lang="less">
.reportLoading {
  position: relative;
  .title {
    text-align: center;
    line-height: 44px;
  }
  .weekTitle {
    position: relative;
  }
  .weekTitle::before {
    position: absolute;
    top: 50%;
    right: -11px;
    margin-top: -4px;
    border: 3px solid;
    border-color: transparent transparent #dcdee0 #dcdee0;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    opacity: 0.8;
    content: "";
  }
  .pieDiv {
    margin-top: 10px;
    width: 100vw;
    height: 110vw;
    box-sizing: border-box;
    .pieCanvas {
      width: 100%;
      height: 100%;
    }
  }
  .greedDiv {
    background-color: #e4e4e4;
    height: 10px;
  }
  .listComSelect {
    display: flex;
    align-items: center;
    padding-left: 16px;
    padding-right: 16px;
    justify-content: space-between;
  }
  .Accout {
    padding: 10px;
    margin: 0;
    text-align: center;
  }

  .pb10 {
    padding-bottom: 10px;
  }
  .elTable {
    margin-bottom: 20px;
    border-right: 1px solid #ebedf0;
    table {
      border-collapse: collapse !important;
    }
  }
}
</style>
<style lang="less">
.reportLoading {
  .van-dropdown-menu__bar {
    box-shadow: none !important;
  }
  .van-divider {
    margin: 0;
  }
  .el-table .cell {
    padding-left: 5px;
    padding-right: 5px;
  }
  .el-table td,
  .el-table th.is-leaf {
    border: 1px solid #ebedf0;
  }
  .elTable {
    table {
      border-collapse: collapse !important;
    }
  }
  .emptyDiv {
    height: calc(100vh - 49px);
    width: 100vw;
    position: absolute;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 5;
  }
  .el-table--scrollable-x .el-table__body-wrapper {
    height: auto !important;
  }
  .van-dropdown-menu__title {
    font-size: 16px;
  }
}
</style>
